import React from "react";

export default () => {
  return (
    <svg
      style={{ width: "100%", maxWidth: 216 }}
      height="43px"
      viewBox="0 0 216 43"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group 11</title>

      <g
        id="Wireframe-v4-Layout"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="PWA-Desktop-Page3---Refrigerant---Human-Comfort"
          transform="translate(-417.000000, -439.000000)"
        >
          <g id="Group-4" transform="translate(52.000000, 409.000000)">
            <g id="Group-3">
              <g id="Group-6" transform="translate(340.000000, 0.000000)">
                <g id="Group-12" transform="translate(25.000001, 29.000001)">
                  <g id="Group-11">
                    <g
                      id="Opteon-Logo"
                      transform="translate(0.000000, 1.200001)"
                    >
                      <path
                        d="M34.988,36.7576 C35.317,36.7486 35.419,36.8936 35.477,37.1216 L36.15,37.0346 C36.073,36.5356 35.816,36.1236 34.988,36.1236 C34.223,36.1236 33.768,36.5836 33.768,37.4306 C33.768,38.2786 34.223,38.7376 34.988,38.7376 C35.816,38.7376 36.073,38.3266 36.15,37.8276 L35.477,37.7416 C35.419,37.9686 35.317,38.1126 34.988,38.1046 C34.645,38.0936 34.441,37.8866 34.441,37.4306 C34.441,36.9756 34.645,36.7676 34.988,36.7576 M34.988,35.4746 C36.068,35.4746 36.944,36.3516 36.944,37.4306 C36.944,38.5106 36.068,39.3866 34.988,39.3866 C33.908,39.3866 33.032,38.5106 33.032,37.4306 C33.032,36.3516 33.908,35.4746 34.988,35.4746"
                        id="Fill-1"
                        fill="#0672BA"
                      ></path>
                      <path
                        d="M44.7546,21.0635 C44.7546,14.5155 47.4456,10.3095 53.9016,10.3095 C60.3586,10.3095 63.0506,14.5155 63.0506,21.0635 C63.0506,27.6125 60.3586,31.8175 53.9016,31.8175 C47.4456,31.8175 44.7546,27.6125 44.7546,21.0635 M48.4656,21.0635 C48.4656,25.0035 49.5376,28.3575 53.9016,28.3575 C58.2676,28.3575 59.3126,25.0035 59.3126,21.0635 C59.3126,17.1235 58.2676,13.7695 53.9016,13.7695 C49.5376,13.7695 48.4656,17.1235 48.4656,21.0635"
                        id="Fill-2"
                        fill="#0672BA"
                      ></path>
                      <path
                        d="M68.8785,29.9275 L68.8785,36.7685 L65.3235,36.7685 L65.3235,21.1435 L65.0885,17.3365 L68.3555,17.3365 L68.6435,19.1475 C69.5575,17.7895 70.9685,16.9645 72.9295,16.9645 C76.8505,16.9645 79.1235,19.5995 79.1235,24.3915 C79.1235,29.1835 76.8505,31.8175 72.9295,31.8175 C71.2565,31.8175 69.8455,31.2325 68.8785,29.9275 M72.1975,20.3715 C70.3685,20.3715 69.1395,21.5705 68.8785,22.7415 L68.8785,26.0415 C69.1395,27.2135 70.3685,28.4115 72.1975,28.4115 C74.0285,28.4115 75.4125,27.1065 75.4125,24.3915 C75.4125,21.6765 74.0285,20.3715 72.1975,20.3715"
                        id="Fill-3"
                        fill="#0672BA"
                      ></path>
                      <path
                        d="M79.9863,17.3368 L82.4423,17.3368 L82.4423,13.6368 L85.9973,12.9458 L85.9973,17.3368 L89.9713,17.3368 L89.9713,20.6108 L85.9973,20.6108 L85.9973,25.9888 C85.9973,27.9578 86.5983,28.3848 87.8793,28.4368 C88.7413,28.4908 89.5523,28.1448 89.8923,27.9578 L90.2313,31.3918 C89.7353,31.6048 88.8723,31.8178 87.8273,31.8178 C83.3053,31.8178 82.4423,29.0498 82.4423,26.1748 L82.4423,20.6108 L79.9863,20.6108 L79.9863,17.3368 Z"
                        id="Fill-4"
                        fill="#0672BA"
                      ></path>
                      <path
                        d="M95.1183,25.7758 C95.2223,27.7718 96.5043,28.6508 98.2823,28.6508 C100.137,28.6768 100.843,27.9318 101.052,26.9728 L104.684,27.4248 C104.319,29.7948 102.777,31.8168 98.3603,31.8168 C93.9413,31.8168 91.3553,29.2088 91.3553,24.3908 C91.3553,19.5728 93.9413,16.9648 98.1773,16.9648 C102.464,16.9648 104.763,19.5998 104.763,24.3908 L104.763,25.7758 L95.1183,25.7758 Z M95.1443,22.9278 L100.947,22.9278 C100.869,21.0378 99.9533,20.1318 98.2023,20.1318 C96.4773,20.1318 95.3273,20.9838 95.1443,22.9278 L95.1443,22.9278 Z"
                        id="Fill-5"
                        fill="#0672BA"
                      ></path>
                      <path
                        d="M106.122,24.3913 C106.122,19.4943 108.735,16.9653 112.918,16.9653 C117.1,16.9653 119.714,19.4943 119.714,24.3913 C119.714,29.2883 117.1,31.8173 112.918,31.8173 C108.735,31.8173 106.122,29.2883 106.122,24.3913 M109.781,24.3913 C109.781,27.3193 110.984,28.4373 112.918,28.4373 C114.852,28.4373 116.054,27.3193 116.054,24.3913 C116.054,21.4633 114.852,20.3453 112.918,20.3453 C110.984,20.3453 109.781,21.4633 109.781,24.3913"
                        id="Fill-6"
                        fill="#0672BA"
                      ></path>
                      <path
                        d="M124.94,19.227 C125.933,17.816 127.502,16.965 129.253,16.965 C132.468,16.965 134.611,18.562 134.611,21.942 L134.611,31.446 L131.056,31.446 L131.056,22.474 C131.056,21.01 130.09,20.372 128.625,20.372 C126.822,20.372 125.489,21.622 125.148,22.714 L125.148,31.446 L121.621,31.446 L121.621,21.144 L121.386,17.337 L124.653,17.337 L124.94,19.227 Z"
                        id="Fill-7"
                        fill="#0672BA"
                      ></path>
                      <path
                        d="M138.179,19.3856 L137.829,18.3436 L137.738,18.0696 L137.746,18.3776 L137.746,19.3856 L137.13,19.3856 L137.13,17.1366 L137.979,17.1366 L138.363,18.2866 L138.462,18.6116 L138.562,18.2866 L138.945,17.1366 L139.795,17.1366 L139.795,19.3856 L139.179,19.3856 L139.179,18.3776 L139.187,18.0696 L139.096,18.3436 L138.746,19.3856 L138.179,19.3856 Z M136.213,19.3856 L135.613,19.3856 L135.613,17.7106 L134.956,17.7106 L134.956,17.1366 L136.871,17.1366 L136.871,17.7106 L136.213,17.7106 L136.213,19.3856 Z"
                        id="Fill-8"
                        fill="#0672BA"
                      ></path>
                      <polygon
                        id="Fill-9"
                        fill="#94B5DE"
                        points="18.4524 0 0.0004 10.519 18.4524 10.519"
                      ></polygon>
                      <polygon
                        id="Fill-10"
                        fill="#689AD1"
                        points="18.4524 10.5192 0.0004 17.4702 18.4524 21.0242"
                      ></polygon>
                      <polygon
                        id="Fill-11"
                        fill="#7CA5D7"
                        points="0.0003 10.5192 0.0003 17.4702 18.4523 10.5192"
                      ></polygon>
                      <polygon
                        id="Fill-12"
                        fill="#0672BA"
                        points="18.4524 42.0492 0.0004 31.5312 0.0004 31.5302 18.4524 31.5302"
                      ></polygon>
                      <polygon
                        id="Fill-13"
                        fill="#2983C5"
                        points="18.4524 31.5301 0.0004 24.5801 18.4524 21.0241"
                      ></polygon>
                      <polygon
                        id="Fill-14"
                        fill="#047FC4"
                        points="0.0003 31.5301 0.0003 24.5801 18.4523 31.5301"
                      ></polygon>
                      <polygon
                        id="Fill-15"
                        fill="#4D8ECB"
                        points="0.0003 17.4699 0.0003 24.5799 18.4523 21.0239"
                      ></polygon>
                      <polygon
                        id="Fill-16"
                        fill="#DCF1FC"
                        points="18.4524 0 36.9044 10.519 18.4524 10.519"
                      ></polygon>
                      <polygon
                        id="Fill-17"
                        fill="#9ADAF8"
                        points="18.4524 10.5192 36.9044 17.4702 18.4524 21.0242"
                      ></polygon>
                      <polygon
                        id="Fill-18"
                        fill="#BCE5FA"
                        points="36.9048 10.5192 36.9048 17.4702 18.4528 10.5192"
                      ></polygon>
                      <polygon
                        id="Fill-19"
                        fill="#29AAE2"
                        points="18.4524 42.0492 36.9044 31.5312 36.9044 31.5302 18.4524 31.5302"
                      ></polygon>
                      <polygon
                        id="Fill-20"
                        fill="#0AC0F1"
                        points="18.4524 31.5301 36.9044 24.5801 18.4524 21.0241"
                      ></polygon>
                      <polygon
                        id="Fill-21"
                        fill="#23B0E6"
                        points="36.9048 31.5301 36.9048 24.5801 18.4528 31.5301"
                      ></polygon>
                      <polygon
                        id="Fill-22"
                        fill="#6ECEF4"
                        points="36.9048 17.4699 36.9048 24.5799 18.4528 21.0239"
                      ></polygon>
                    </g>
                    <path
                      d="M150.373999,33 L153.649999,28.06 L155.885999,24.654 L158.121999,28.06 L161.397999,33 L164.543999,33 L158.433999,24.108 L157.341999,22.548 L158.381999,21.066 L164.075999,12.72 L161.033999,12.72 L158.173999,17.01 L155.885999,20.494 L153.597999,17.01 L150.737999,12.72 L147.695999,12.72 L153.389999,21.066 L154.429999,22.548 L153.337999,24.108 L147.227999,33 L150.373999,33 Z M180.247999,33 L180.247999,30.608 L169.951999,30.608 L169.951999,12.72 L167.351999,12.72 L167.351999,33 L180.247999,33 Z M197.459999,33 L197.459999,30.66 L190.387999,30.66 L184.745999,30.686 C184.875999,27.956 186.929999,26.734 190.673999,25.044 L191.106246,24.8517372 C194.127809,23.5227851 197.017999,22.5007273 197.017999,18.778 C197.017999,14.826 193.793999,12.85 189.971999,12.85 C184.875999,12.85 182.743999,15.112 182.327999,18.388 L184.901999,18.648 C185.109999,15.944 187.579999,15.19 189.971999,15.19 C191.687999,15.19 194.495999,15.84 194.495999,18.778 C194.495999,21.326 191.947999,22.028 189.607999,23.068 C185.291999,24.862 182.041999,26.448 182.041999,32.844 L182.041999,33 L197.459999,33 Z M207.885999,33.312 C213.345999,33.312 215.425999,29.932 215.425999,23.068 C215.425999,16.204 213.319999,12.824 207.885999,12.824 C202.425999,12.824 200.345999,16.204 200.345999,23.068 C200.345999,29.932 202.451999,33.312 207.885999,33.312 Z M207.885999,30.998 C204.349999,30.998 202.945999,28.71 202.945999,23.068 C202.945999,17.426 204.349999,15.138 207.885999,15.138 C211.421999,15.138 212.825999,17.426 212.825999,23.068 C212.825999,28.71 211.421999,30.998 207.885999,30.998 Z"
                      id="XL20"
                      fill="#0672BA"
                      fillRule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
